/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserIdentityResponse
 */
export interface UserIdentityResponse {
    /**
     * 
     * @type {string}
     * @memberof UserIdentityResponse
     */
    subject?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserIdentityResponse
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserIdentityResponse
     */
    username?: string | null;
}

/**
 * Check if a given object implements the UserIdentityResponse interface.
 */
export function instanceOfUserIdentityResponse(value: object): value is UserIdentityResponse {
    return true;
}

export function UserIdentityResponseFromJSON(json: any): UserIdentityResponse {
    return UserIdentityResponseFromJSONTyped(json, false);
}

export function UserIdentityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserIdentityResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'subject': json['subject'] == null ? undefined : json['subject'],
        'email': json['email'] == null ? undefined : json['email'],
        'username': json['username'] == null ? undefined : json['username'],
    };
}

export function UserIdentityResponseToJSON(json: any): UserIdentityResponse {
    return UserIdentityResponseToJSONTyped(json, false);
}

export function UserIdentityResponseToJSONTyped(value?: UserIdentityResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subject': value['subject'],
        'email': value['email'],
        'username': value['username'],
    };
}

